export default __webpack_public_path__ + "static/media/error-file-icon.bccece43.svg";